import { render, staticRenderFns } from "./owner.vue?vue&type=template&id=3cb03bea&scoped=true"
import script from "./owner.vue?vue&type=script&lang=js"
export * from "./owner.vue?vue&type=script&lang=js"
import style0 from "./owner.vue?vue&type=style&index=0&id=3cb03bea&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cb03bea",
  null
  
)

export default component.exports